import { render, staticRenderFns } from "./StickyHeaderLayout.vue?vue&type=template&id=16a5bd64&scoped=true&"
import script from "./StickyHeaderLayout.vue?vue&type=script&lang=js&"
export * from "./StickyHeaderLayout.vue?vue&type=script&lang=js&"
import style0 from "./StickyHeaderLayout.vue?vue&type=style&index=0&id=16a5bd64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a5bd64",
  null
  
)

export default component.exports